import {
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

import { SearchablePopoverSearchProps } from "./searchable-popover.types";
import { CustomTextField } from "../formsComponents";

export const SearchablePopoverSearch = ({
  value,
  placeholder = "Search...",
  onChange,
  onClear,
}: SearchablePopoverSearchProps) => {
  return (
    <CustomTextField
      autoFocus
      fullWidth
      size="small"
      value={value}
      placeholder={placeholder}
      onChange={(event) => onChange(event.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              edge="end"
              onClick={onClear}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : undefined,
      }}
    />
  );
};